"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Speakers = function Speakers(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "22px",
    height: "28px",
    viewBox: "0 0 22 28",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1203.000000, -2759.000000)",
    stroke: fill,
    strokeWidth: "2.5"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1205.000000, 2761.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "0.160714286 0.160714286 17.8392857 0.160714286 17.8392857 24.2678571 0.160714286 24.2678571"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.39285714,15.4285714 C7.39285714,16.3161719 8.11239951,17.0357143 9,17.0357143 C9.88760049,17.0357143 10.6071429,16.3161719 10.6071429,15.4285714 C10.6071429,14.5409709 9.88760049,13.8214286 9,13.8214286 C8.11239951,13.8214286 7.39285714,14.5409709 7.39285714,15.4285714 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.39285714,4.98214286 C7.39285714,5.86974335 8.11239951,6.58928571 9,6.58928571 C9.88760049,6.58928571 10.6071429,5.86974335 10.6071429,4.98214286 C10.6071429,4.09454237 9.88760049,3.375 9,3.375 C8.11239951,3.375 7.39285714,4.09454237 7.39285714,4.98214286 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.375,15.4285714 C3.375,18.5351731 5.89339828,21.0535714 9,21.0535714 C12.1066017,21.0535714 14.625,18.5351731 14.625,15.4285714 C14.625,12.3219697 12.1066017,9.80357143 9,9.80357143 C5.89339828,9.80357143 3.375,12.3219697 3.375,15.4285714 Z"
  })))));
};
Speakers.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Speakers.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Speakers;